import { Combobox } from '@components/combobox/Combobox';
import type { GuestTag } from 'restaurantAdmin/restaurants/apiHelpers';
import { useGuestTags } from 'restaurantAdmin/hooks/useGuestTags';

interface GuestTagComboboxProps {
  onChange: (value: (GuestTag | string)[]) => void;
  defaultValue: (string | GuestTag)[];
  name?: string;
}

export const GuestTagCombobox = ({
  onChange,
  defaultValue,
  name,
}: GuestTagComboboxProps) => {
  const { data: allTags } = useGuestTags();

  return (
    <Combobox
      aria-label="Guest Tags"
      name={name}
      getOptionLabel={(tag) => tag.title}
      onChange={onChange}
      options={allTags}
      placeholder="Select Guest Tags"
      value={defaultValue}
    />
  );
};
